import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface GeneralDropdownsTriggersTriggerPowerSelectChevronSignature {
  Args: {
    isDisabled?: boolean;
  };
}

const GeneralDropdownsTriggersTriggerPowerSelectChevron = <template>
  <div class="flex items-center">
    <PrismButton
      @buttonType="secondary"
      @icon="chevron-down"
      @isDisabled={{@isDisabled}}
    />
  </div>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerPowerSelectChevronSignature>;

export default GeneralDropdownsTriggersTriggerPowerSelectChevron;
